import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

export default function HeroDesignSection({
  editedSection,
  t,
  flags,
  onStyleChange,
}) {
  const { isHero } = flags;

  const templateKey = String(editedSection?.template || "").toLowerCase().trim();

  const isHeroTemplate1 =
    isHero &&
    (templateKey === "1" || templateKey === "template1" || templateKey.endsWith("template1"));

  const isHeroTemplate2 =
    isHero &&
    (templateKey === "2" || templateKey === "template2" || templateKey.endsWith("template2"));

  const isHeroTemplate3 =
    isHero &&
    (templateKey === "3" || templateKey === "template3" || templateKey.endsWith("template3"));

  if (!isHeroTemplate1 && !isHeroTemplate2 && !isHeroTemplate3) return null;

  return (
    <>
      {isHeroTemplate1 && (
        <EditorGroup
          title={t("sectionModal.heroBadge.title", "Template 1 Badge")}
          subtitle={t(
            "sectionModal.heroBadge.help",
            "Customize the floating badge colors for Hero Template 1"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.heroBadge.bg", "Badge Background")}
              type="color"
              value={editedSection?.style?.heroBadgeBg}
              onChange={(v) => onStyleChange("heroBadgeBg", v)}
            />
            <Field
              label={t("sectionModal.heroBadge.border", "Badge Border")}
              type="color"
              value={editedSection?.style?.heroBadgeBorder}
              onChange={(v) => onStyleChange("heroBadgeBorder", v)}
            />
            <Field
              label={t("sectionModal.heroBadge.titleColor", "Badge Title Color")}
              type="color"
              value={editedSection?.style?.heroBadgeTitleColor}
              onChange={(v) => onStyleChange("heroBadgeTitleColor", v)}
            />
            <Field
              label={t("sectionModal.heroBadge.subtitleColor", "Badge Subtitle Color")}
              type="color"
              value={editedSection?.style?.heroBadgeSubtitleColor}
              onChange={(v) => onStyleChange("heroBadgeSubtitleColor", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isHeroTemplate2 && (
        <EditorGroup
          title={t("sectionModal.heroTag.title", "Template 2 Tag")}
          subtitle={t(
            "sectionModal.heroTag.help",
            "Customize the top tag colors for Hero Template 2"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.heroTag.bg", "Tag Background")}
              type="color"
              value={editedSection?.style?.heroTagBg}
              onChange={(v) => onStyleChange("heroTagBg", v)}
            />
            <Field
              label={t("sectionModal.heroTag.border", "Tag Border")}
              type="color"
              value={editedSection?.style?.heroTagBorder}
              onChange={(v) => onStyleChange("heroTagBorder", v)}
            />
            <Field
              label={t("sectionModal.heroTag.text", "Tag Text Color")}
              type="color"
              value={editedSection?.style?.heroTagTextColor}
              onChange={(v) => onStyleChange("heroTagTextColor", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isHeroTemplate3 && (
        <EditorGroup
          title={t("sectionModal.heroStats.title", "Template 3 Stats")}
          subtitle={t(
            "sectionModal.heroStats.help",
            "Customize the stat cards colors for Hero Template 3"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.heroStats.cardBg", "Stats Card Background")}
              type="color"
              value={editedSection?.style?.statsCardBg}
              onChange={(v) => onStyleChange("statsCardBg", v)}
            />
            <Field
              label={t("sectionModal.heroStats.cardBorder", "Stats Card Border")}
              type="color"
              value={editedSection?.style?.statsCardBorder}
              onChange={(v) => onStyleChange("statsCardBorder", v)}
            />
            <Field
              label={t("sectionModal.heroStats.valueColor", "Stats Value Color")}
              type="color"
              value={editedSection?.style?.statsValueColor}
              onChange={(v) => onStyleChange("statsValueColor", v)}
            />
            <Field
              label={t("sectionModal.heroStats.labelColor", "Stats Label Color")}
              type="color"
              value={editedSection?.style?.statsLabelColor}
              onChange={(v) => onStyleChange("statsLabelColor", v)}
            />
          </div>
        </EditorGroup>
      )}
    </>
  );
}